module.exports = __webpack_public_path__ + "img/img3.f99fa198.png";